module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado16.53fabcf6.svg";